"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4972],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 54972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_ResumeOfferModalContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./src/uikit/Buttons/Secondary.tsx
var Secondary = __webpack_require__(66866);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var modal_dist_index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./src/uikit/Badges/LimitedOffer.tsx + 1 modules
var LimitedOffer = __webpack_require__(94999);
// EXTERNAL MODULE: ./src/components/OfferPreviewCard/index.tsx + 2 modules
var OfferPreviewCard = __webpack_require__(73140);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ResumeOfferModal/OfferPreviewCardContainer.tsx








const OfferPreviewCardContainer = _ref => {
  let {
    offerData
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
    bg: "baseWhite",
    borderRadius: "10px",
    p: "l",
    width: isMobile ? '100%' : '66%',
    mx: "auto",
    mt: "xl",
    boxShadow: "md",
    position: "relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOffer/* default */.Z, {
      marginTop: "-35px",
      marginBottom: "10px",
      textAlign: "center",
      children: t('resumeOfferModalContainer:expiringOfferBadge')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferPreviewCard["default"], {
      offerData: offerData
    })]
  });
};

/* harmony default export */ var ResumeOfferModal_OfferPreviewCardContainer = (OfferPreviewCardContainer);
;// CONCATENATED MODULE: ./src/components/ResumeOfferModal/index.tsx








const ResumeOfferModal = _ref => {
  let {
    customizedOffer,
    title,
    subTitle,
    description,
    descsecureDataTextription,
    closeText,
    closeTextMobile,
    submitText,
    submitAction,
    isOpen,
    onClose
  } = _ref;

  if (!customizedOffer) {
    return null;
  }

  const isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
    onClose: onClose,
    isOpen: isOpen,
    size: "xl",
    isCentered: true,
    closeOnOverlayClick: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
      backgroundColor: "baseNeutral.100",
      minWidth: isMobile ? null : '890px',
      borderRadius: "10px",
      px: isMobile ? 'xl' : 'xxl',
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
        borderBottom: "1px solid #dadde1",
        fontFamily: "Montserrat-SemiBold",
        px: "0",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
        mt: "1"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
        m: "0",
        px: "0",
        pb: "xl",
        pt: "l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          fontSize: {
            base: '1rem',
            md: '1.125rem'
          },
          color: "baseDark",
          mb: "l",
          children: subTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: '0.875rem',
            md: '1rem'
          },
          color: "baseDark",
          children: description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ResumeOfferModal_OfferPreviewCardContainer, {
          offerData: customizedOffer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
          fontFamily: "Montserrat-Medium",
          fontSize: "0.625rem",
          color: "baseDark",
          textAlign: "center",
          mt: "s",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* LockIcon */.mB, {}), " ", descsecureDataTextription]
        }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
          width: "66%",
          mx: "auto",
          mt: "xl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
              variant: "ghost",
              fontFamily: "Montserrat-Medium",
              color: "primaryGreen.800",
              fontSize: "1rem",
              textTransform: "uppercase",
              fontWeight: "normal",
              onClick: onClose,
              children: closeText
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Spacer */.LZ, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Secondary/* default */.Z, {
              title: submitText,
              action: submitText.toUpperCase(),
              fontSize: "1rem",
              onClick: submitAction
            })
          })]
        })]
      }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
        px: "0",
        mx: "0",
        justifyContent: "space-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
          variant: "ghost",
          fontFamily: "Montserrat-Medium",
          color: "primaryGreen.800",
          fontSize: "1rem",
          textTransform: "uppercase",
          fontWeight: "normal",
          onClick: onClose,
          children: closeTextMobile
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Secondary/* default */.Z, {
          title: submitText,
          action: submitText.toUpperCase(),
          fontSize: "1rem",
          onClick: submitAction,
          width: "inherit"
        })]
      })]
    })]
  });
};

/* harmony default export */ var components_ResumeOfferModal = (ResumeOfferModal);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
;// CONCATENATED MODULE: ./src/containers/ResumeOfferModalContainer.tsx










const ResumeOfferModalContainer = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const router = (0,next_router.useRouter)();
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,index_esm/* useDisclosure */.qY)();
  const [cookies, setCookie] = (0,useCookies/* default */.Z)();
  const user = (0,es/* useSelector */.v9)(state => {
    var _state$user;

    return (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.profile;
  });
  const customizedOffer = (0,es/* useSelector */.v9)(state => {
    var _state$user2, _state$user2$profile;

    return (_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : (_state$user2$profile = _state$user2.profile) === null || _state$user2$profile === void 0 ? void 0 : _state$user2$profile.deal;
  });
  const customizeModalIsOpen = (0,es/* useSelector */.v9)(state => state.nlt.customizeModalIsOpen);

  const closeHanlder = () => {
    setCookie('resumeOfferModalHidden', true, {
      path: '/'
    });
    onClose();
  };

  (0,react.useEffect)(() => {
    if (customizedOffer && !cookies.resumeOfferModalHidden) {
      onOpen();
    }
  });

  if (!user || !customizedOffer || !customizedOffer.deal || customizeModalIsOpen) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_ResumeOfferModal, {
    customizedOffer: customizedOffer,
    title: t('resumeOfferModalContainer:title', {
      username: user.firstName
    }),
    subTitle: t('resumeOfferModalContainer:subTitle', {
      car: customizedOffer.vehicle.name
    }),
    description: t('resumeOfferModalContainer:description'),
    descsecureDataTextription: t('resumeOfferModalContainer:secureDataText'),
    closeText: t('resumeOfferModalContainer:closeText'),
    closeTextMobile: t('resumeOfferModalContainer:closeTextMobile'),
    submitText: t('resumeOfferModalContainer:submitText'),
    submitAction: () => {
      if (customizedOffer.qualification.isQualified) {
        router.push(`/caricamento-documenti`);
      } else {
        router.push(`/noleggio-a-lungo-termine/${customizedOffer.offerCode}`).then(() => {
          closeHanlder();
          dispatch((0,actions/* toggleCustomizeModal */.K2)({
            step: 3
          }));
        });
      }
    },
    isOpen: isOpen,
    onClose: closeHanlder
  });
};

/* harmony default export */ var containers_ResumeOfferModalContainer = (ResumeOfferModalContainer);

/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badges_LimitedOffer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/clock.tsx


const ClockIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.272 12.673c.228-.214.228-.56 0-.773l-1.033-.968c.753-.875 1.203-1.99 1.203-3.201.002-.761-.175-1.483-.491-2.13.542-.468.882-1.137.882-1.883 0-1.41-1.217-2.551-2.722-2.551-1.1 0-2.049.61-2.477 1.492-.42-.046-.848-.046-1.268 0-.428-.882-1.376-1.492-2.477-1.492-1.505 0-2.722 1.141-2.722 2.551 0 .746.34 1.415.882 1.882-.316.648-.493 1.37-.493 2.129 0 1.212.452 2.326 1.203 3.2l-1.033.969c-.229.214-.229.56 0 .772.228.215.598.215.824 0l1.033-.968c1.98 1.497 4.83 1.513 6.83 0l1.035.97c.228.215.598.215.824 0zm-.946-8.045c-.636-.78-1.507-1.381-2.51-1.714.277-.394.753-.654 1.295-.654.858 0 1.556.654 1.556 1.458 0 .345-.13.661-.34.91zm-8.65 0c-.214-.249-.343-.565-.343-.91 0-.804.698-1.458 1.556-1.458.542 0 1.018.26 1.298.654-1.006.333-1.877.934-2.511 1.714zM7 11.738c-2.365 0-4.278-1.793-4.278-4.01 0-2.21 1.906-4.01 4.278-4.01 2.367 0 4.278 1.796 4.278 4.01 0 2.217-1.913 4.01-4.278 4.01zm1.531-2.25l.44-.602c.09-.125.059-.294-.075-.38L7.68 7.721V5.268c0-.15-.132-.274-.292-.274H6.61c-.16 0-.292.123-.292.274V8.25c0 .091.047.176.127.226l1.677 1.082c.134.084.316.052.408-.07z",
        transform: "translate(-413 -1472) translate(45 1377) translate(344 75) translate(16 16) translate(8 4)"
      })
    })
  })
});

/* harmony default export */ var clock = (ClockIcon);
;// CONCATENATED MODULE: ./src/uikit/Badges/LimitedOffer.tsx


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const LimitedOfferStyle = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  componentId: "sc-1kch8fu-0"
})(["& svg{display:inline;margin-right:4px;vertical-align:sub;}"]);

const LimitedOffer = _ref => {
  let {
    children
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOfferStyle, _objectSpread(_objectSpread({}, others), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
      bg: "feedbackWarning",
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.625rem",
      lineHeight: "15.6px",
      letterSpacing: ".33px",
      rounded: "15px",
      paddingY: ".3rem",
      paddingX: ".5rem",
      textTransform: "initial",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), children]
    })
  }));
};

/* harmony default export */ var Badges_LimitedOffer = (LimitedOffer);

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["title", "width", "action", "disabled", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const SecondaryButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_ref, ref) => {
  let {
    title,
    width,
    action,
    disabled,
    onClick
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const buttonSize = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)(['md', 'lg']);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, _objectSpread(_objectSpread({
    variant: "outline",
    bg: "baseWhite",
    color: "primaryGreen.900",
    fontFamily: "Montserrat-SemiBold",
    borderRadius: 4,
    display: "block",
    overflow: "hidden",
    title: title,
    disabled: disabled,
    width: width || '100%',
    size: buttonSize,
    borderColor: "primaryGreen.300",
    px: {
      base: '0.75rem',
      md: '1rem'
    },
    _active: {
      bg: 'primaryGreen.800',
      borderColor: 'primaryGreen.800',
      color: 'baseWhite'
    },
    _hover: {
      bg: disabled ? '' : 'primaryGreen.900',
      borderColor: disabled ? '' : 'primaryGreen.900',
      color: disabled ? '' : 'baseWhite'
    },
    _disabled: {
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    },
    onClick: onClick
  }, others), {}, {
    children: action
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (SecondaryButton);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);